import { useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { AuthContext } from './contexts/AuthContext';
import WebLayout from './layouts/WebLayout';
import AdminLayout from './layouts/AdminLayout';
import Home from './pages/home/Home';
import About from './pages/about/About';
import FindTeacher from './pages/teacher/FindTeacher';
import TeacherProfile from './pages/teacher/TeacherProfile';
import Dashboard from './pages/admin/dashboard/Dashboard';
import PendingApprovals from './pages/admin/pending_approvals/PendingApprovals';
import Teachers from './pages/admin/teachers/Teachers';
import CreateTeacher from './pages/admin/teachers/CreateTeacher';
import EditTeacher from './pages/admin/teachers/EditTeacher';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ParentLanding from './pages/parent/ParentLanding';
import ParentStudents from './pages/parent/ParentStudents';
import ParentStudentClasses from './pages/parent/ParentStudentClasses';
import ParentProtectedRoute from './routes/ParentProtectedRoute';
import RoleProtectedRoute from './routes/RoleProtectedRoute';
import { AUTH_ROLES } from './utils/auth';
import './App.css';

function App() {
  const { user, authLoading } = useContext(AuthContext);

  if (authLoading) return null;

  return (
    <div className="app">
      <Routes>
        {/* Web routes */}
        <Route element={<WebLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />

          <Route path="/teacher/:id" element={<TeacherProfile />} />
          <Route path="/find-teacher" element={<FindTeacher />} />
        </Route>

        <Route
          path="/parent"
          element={
            <ParentProtectedRoute>
              <ParentLanding />
            </ParentProtectedRoute>
          }
        />
        <Route
          path="/parent/students"
          element={
            <ParentProtectedRoute>
              <ParentStudents />
            </ParentProtectedRoute>
          }
        />
        <Route
          path="/parent/student-classes"
          element={
            <RoleProtectedRoute allowedRoles={[AUTH_ROLES.PARENT, AUTH_ROLES.STUDENT]} redirectTo="/">
              <ParentStudentClasses />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/parent/students/:studentId"
          element={
            <ParentProtectedRoute>
              <ParentStudentClasses />
            </ParentProtectedRoute>
          }
        />

        {/* Admin routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute allowedRoles={[1]} userRole={user?.role} redirectTo="/">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="pending-approvals"
            element={
              <ProtectedRoute allowedRoles={[1]} userRole={user?.role} redirectTo="/">
                <PendingApprovals />
              </ProtectedRoute>
            }
          />
          <Route
            path="teachers"
            element={
              <ProtectedRoute allowedRoles={[1]} userRole={user?.role} redirectTo="/">
                <Teachers />
              </ProtectedRoute>
            }
          />
          <Route
            path="create-teacher"
            element={
              <ProtectedRoute allowedRoles={[1]} userRole={user?.role} redirectTo="/">
                <CreateTeacher />
              </ProtectedRoute>
            }
          />
          <Route
            path="edit-teacher/:id"
            element={
              <ProtectedRoute allowedRoles={[1]} userRole={user?.role} redirectTo="/">
                <EditTeacher />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
